"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefreshInterval = exports.fallbackFlag = exports.toQueryParams = exports.toFlagsObject = exports.fetcher = exports.parseResponse = void 0;
const constants_1 = require("./constants");
const types_1 = require("./types");
const parseResponse = (response) => {
    if (response.headers.get("content-type")?.includes("json")) {
        return response.json();
    }
    return response.text();
};
exports.parseResponse = parseResponse;
const fetcher = async ([url, token, method], param) => {
    const response = await fetch(url, {
        method,
        headers: { Authorization: token, "Content-Type": "application/json" },
        ...(param?.arg && { body: JSON.stringify(param?.arg) }),
    });
    const responsePayload = await (0, exports.parseResponse)(response);
    if (response.ok)
        return responsePayload;
    throw new types_1.Error({
        message: typeof responsePayload === "string"
            ? responsePayload
            : JSON.parse(responsePayload),
        status: response.status,
    });
};
exports.fetcher = fetcher;
const toFlagsObject = (flags) => {
    try {
        return (flags.reduce((acc, curr) => ({ ...acc, [curr.name]: curr }), {}) || {});
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
exports.toFlagsObject = toFlagsObject;
const toQueryParams = (userId, properties) => new URLSearchParams(`userId=${userId}${Object.entries(properties).reduce((acc, [key, value]) => `${acc}&properties[${key}]=${value}`, "")}`).toString();
exports.toQueryParams = toQueryParams;
const fallbackFlag = (name) => {
    return {
        enabled: false,
        name,
        variant: constants_1.EMPTY_VARIANT,
    };
};
exports.fallbackFlag = fallbackFlag;
const getRefreshInterval = (refreshIntervalSeconds) => {
    if (!refreshIntervalSeconds)
        return 3600;
    if (refreshIntervalSeconds < 60)
        return 60;
    return refreshIntervalSeconds;
};
exports.getRefreshInterval = getRefreshInterval;
//# sourceMappingURL=utils.js.map